<template lang="pug">
    .z-input-multy-value(v-bind:class="{'inline': $props.inline, 'focus': focus, 'has-value': (val && val.length), 'no-value': (!val || !val.length)}")
        label(v-if="$props.label") {{$props.label}}
        .zimv__value-container
            .zimv__value(v-if="(val && val.length)")
                .zimv__value-preview__item(v-for="item in val" v-on:click="removeValue(item)")
                    span {{item}}

            input.zimv__value-input(
                v-model="newValue"
                v-bind:type="$props.valueType"
                v-bind:placeholder="$props.placeholder"

                v-on:keypress="onInputKeyPress"
                v-on:focus="onFocus"
                v-on:blur="onBlur"
            )

            .zimv__add(v-bind:class="{'disabled': (!newValue || !newValue.length)}" v-on:click="addValue")
                md-icon.small add
</template>
<script>
    export default {
        name: 'z-input-multy-value',
        components: {},
        props: {
            id: {
                type: String,
                default: 'z-input-multy-value'
            },
            name: {
                type: String,
                default: 'z-input-multy-value'
            },
            label: {
                type: String,
                default: ''
            },
            valueType: {
                type: String,
                default: 'text'
            },
            value: {
                type: Array,
                default: () => []
            },
            inline: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                val: [],
                focus: false,
                newValue: ''
            }
        },
        created() {
            if (this.$props.value) this.val = Object.assign([], this.$props.value);
        },
        watch: {
            'value': {
                deep: true,
                handler(value) {
                    if (JSON.stringify(this.val) != JSON.stringify(value)) this.val = Object.assign([], value);
                }
            },
            'val'(val) {
                this.$emit('input', val);
                this.$emit('change', val);
            }
        },
        computed: {},
        methods: {
            onInputKeyPress(e) {
                if (e.key != 'Enter' && e.keyCode != 13) return;
                this.addValue();
            },
            addValue() {
                if (!this.newValue || this.val.find(item => item == this.newValue)) return;
                this.val.push(this.newValue);
                this.newValue = null;
            },
            removeValue(value) {
                if (!value) return;
                let i = this.val.findIndex(item => item == value);
                if (!i && i != 0) return;
                this.val.splice(i, 1);
            },
            resize() {

            },
            onFocus(e) {
                this.focus = true;
                this.$emit('focus', e);
            },
            onBlur(e) {
                this.focus = false;
                this.$emit('blur', e);
            },
        }
    }
</script>
<style lang="sass">
    .z-input-multy-value
        display: flex
        align-items: flex-start
        justify-content: flex-start
        flex-direction: column
        position: relative
        margin: 4px 0 10px 0
        width: 100%
        .zimv__value-container
            display: flex
            align-items: flex-start
            justify-content: space-between
            width: 100%
        label
            display: block
            color: rgba(0, 0, 0, 0.54)
            font-size: 12px
            font-weight: 500
            line-height: 12px
            transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)
            transition-duration: .3s
            z-index: 5
            resize: none
            margin-bottom: 10px
        .zimv__value
            flex-shrink: 0
            display: flex
            align-items: center
            justify-content: flex-start
            flex-wrap: wrap
            max-width: calc(100% - 190px)
            min-height: 30px
            padding: 2px
            background: #F1F1F1
            .zimv__value-preview__item
                padding: 2px 4px
                margin: 2px
                background: #fff
                font-weight: 400
                line-height: 16px
                color: #000
                cursor: pointer
                transition: 0.25s ease
                span
                &:hover
                    background: #2196f3
                    color: #fff
        .zimv__value-input
            flex-shrink: 1
            width: 100%
            min-width: 150px
            margin: 0 0 0 10px
            line-height: 16px
            padding: 7px 10px
            border: 0
            outline: none !important
            color: #000
            font-weight: 400
            min-height: 30px
            height: 100%
            background: #F1F1F1

        .zimv__add
            display: flex
            align-items: center
            justify-content: center
            font-size: 12px
            cursor: pointer
            transition: 0.1s
            height: 30px
            width: 30px
            margin: 0 0 0 5px
            border-radius: 3px
            background: #2196f3
            flex-shrink: 0
            .md-icon
            &.disabled
                opacity: 0.5

    .z-input-multy-value.focus
        label
            color: #2196f3

    .z-input-multy-value.inline
        flex-direction: row
        align-items: center
        label
            width: 40%
            flex: 0 0 40%
            padding-right: 8px
            margin: 0
    .z-input-multy-value.no-value
        .zimv__value-input
            margin-left: 0
</style>


// WEBPACK FOOTER //
// ZInputMultyValue.vue?b836f110